import React, { useEffect, useState } from 'react';
import { getMyAlerts, createAlert, deleteAlert, getInvestorDigest } from '../../api';

function NewsSection({ news, loading }) {
  if (loading) return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h2 style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 22 }}>📰</span> News
      </h2>
      <div style={{ textAlign: 'center', padding: 30, color: 'var(--text-light)' }}>
        <div className="loading-spinner" style={{ margin: '0 auto 12px', width: 24, height: 24, border: '3px solid #e0e0e0', borderTopColor: 'var(--primary)', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        Recherche des dernières actualités...
      </div>
    </div>
  );

  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h2 style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 22 }}>📰</span> News
        <span style={{ fontSize: 12, color: 'var(--text-light)', fontWeight: 400, marginLeft: 8 }}>Actualités de moins d'un mois</span>
      </h2>

      {news.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 30, color: 'var(--text-light)', fontSize: 14 }}>
          Aucune actualité récente trouvée pour vos startups suivies.
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          {news.map((item, idx) => (
            <div key={idx} style={{ borderLeft: '3px solid var(--primary)', paddingLeft: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                {item.logo_url && <img src={item.logo_url} alt="" style={{ width: 20, height: 20, borderRadius: 4 }} onError={e => e.target.style.display = 'none'} />}
                <strong style={{ color: 'var(--primary)' }}>{item.startup_name}</strong>
                {item.categorie && <span className="badge badge-secteur" style={{ fontSize: 10 }}>{item.categorie}</span>}
                <span style={{ fontSize: 11, color: 'var(--text-light)', marginLeft: 'auto' }}>
                  {item.source?.map(s => s === 'watchlist' ? '⭐' : '💼').join(' ')}
                </span>
              </div>
              {/* Web news (Google News) */}
              {item.web_news?.map((n, i) => (
                <div key={`web-${i}`} style={{ marginBottom: 10, padding: '8px 12px', background: '#F8F9FA', borderRadius: 6 }}>
                  <div style={{ fontSize: 13, marginBottom: 4 }}>{n.title}</div>
                  <div style={{ display: 'flex', gap: 12, fontSize: 11, color: 'var(--text-light)' }}>
                    {n.source && <span>📌 {n.source}</span>}
                    {n.date && <span>🗓 {new Date(n.date).toLocaleDateString('fr-FR')}</span>}
                    <a href={n.url} target="_blank" rel="noopener noreferrer"
                       style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                      Lire →
                    </a>
                  </div>
                </div>
              ))}
              {/* Site news (from startup website) */}
              {item.site_news?.map((n, i) => (
                <div key={`site-${i}`} style={{ marginBottom: 10, padding: '8px 12px', background: '#FFF8E1', borderRadius: 6 }}>
                  <div style={{ fontSize: 13, marginBottom: 4 }}>🌐 {n.title}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-light)' }}>
                    <a href={n.url} target="_blank" rel="noopener noreferrer"
                       style={{ color: '#F57F17', textDecoration: 'none' }}>
                      Voir sur le site →
                    </a>
                  </div>
                </div>
              ))}
              {(!item.web_news || item.web_news.length === 0) && (!item.site_news || item.site_news.length === 0) && (
                <div style={{ fontSize: 13, color: 'var(--text-light)', fontStyle: 'italic' }}>Aucune actualité récente.</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function DirigeantSection({ dirigeants, loading }) {
  if (loading) return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h2 style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 22 }}>👤</span> Informations Dirigeants
      </h2>
      <div style={{ textAlign: 'center', padding: 30, color: 'var(--text-light)' }}>
        <div className="loading-spinner" style={{ margin: '0 auto 12px', width: 24, height: 24, border: '3px solid #e0e0e0', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        Recherche d'informations sur les dirigeants...
      </div>
    </div>
  );

  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h2 style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 22 }}>👤</span> Informations Dirigeants
        <span style={{ fontSize: 12, color: 'var(--text-light)', fontWeight: 400, marginLeft: 8 }}>Mentions de moins d'un mois</span>
      </h2>

      {dirigeants.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 30, color: 'var(--text-light)', fontSize: 14 }}>
          Aucune mention récente des dirigeants de vos startups suivies.
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          {dirigeants.map((item, idx) => (
            <div key={idx} style={{ borderLeft: '3px solid var(--accent)', paddingLeft: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                {item.logo_url && <img src={item.logo_url} alt="" style={{ width: 20, height: 20, borderRadius: 4 }} onError={e => e.target.style.display = 'none'} />}
                <strong style={{ color: 'var(--accent)' }}>{item.dirigeant_name}</strong>
                <span style={{ fontSize: 12, color: 'var(--text-light)' }}>— {item.startup_name}</span>
              </div>
              {item.news?.map((n, i) => (
                <div key={i} style={{ marginBottom: 10, padding: '8px 12px', background: '#FFF3E0', borderRadius: 6 }}>
                  <div style={{ fontSize: 13, marginBottom: 4 }}>{n.title}</div>
                  <div style={{ display: 'flex', gap: 12, fontSize: 11, color: 'var(--text-light)' }}>
                    {n.source && <span>📌 {n.source}</span>}
                    {n.date && <span>🗓 {new Date(n.date).toLocaleDateString('fr-FR')}</span>}
                    <a href={n.url} target="_blank" rel="noopener noreferrer"
                       style={{ color: 'var(--accent)', textDecoration: 'none' }}>
                      Lire →
                    </a>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function BodaccSection({ bodacc, loading }) {
  if (loading) return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h2 style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 22 }}>⚖️</span> BODACC
      </h2>
      <div style={{ textAlign: 'center', padding: 30, color: 'var(--text-light)' }}>
        <div className="loading-spinner" style={{ margin: '0 auto 12px', width: 24, height: 24, border: '3px solid #e0e0e0', borderTopColor: '#E74C3C', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        Interrogation du BODACC...
      </div>
    </div>
  );

  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h2 style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 22 }}>⚖️</span> BODACC
        <span style={{ fontSize: 12, color: 'var(--text-light)', fontWeight: 400, marginLeft: 8 }}>Publications de moins d'un mois</span>
      </h2>

      {bodacc.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 30, color: 'var(--text-light)', fontSize: 14 }}>
          Aucune publication BODACC récente pour vos startups suivies.
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          {bodacc.map((item, idx) => (
            <div key={idx} style={{ borderLeft: '3px solid #E74C3C', paddingLeft: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                {item.logo_url && <img src={item.logo_url} alt="" style={{ width: 20, height: 20, borderRadius: 4 }} onError={e => e.target.style.display = 'none'} />}
                <strong style={{ color: '#C62828' }}>{item.startup_name}</strong>
                <span style={{ fontSize: 11, color: 'var(--text-light)' }}>SIRET: {item.siret}</span>
              </div>
              {item.records?.map((r, i) => {
                const familleColor = (r.famille_avis || '').toLowerCase().includes('vente') ? '#E74C3C'
                  : (r.famille_avis || '').toLowerCase().includes('création') ? '#27AE60'
                  : (r.famille_avis || '').toLowerCase().includes('modif') ? '#F39C12'
                  : '#666';
                return (
                  <div key={i} style={{ marginBottom: 10, padding: '8px 12px', background: '#FFEBEE', borderRadius: 6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 8 }}>
                      <div>
                        <span className="badge" style={{ background: familleColor, color: 'white', fontSize: 10, marginRight: 8 }}>
                          {r.famille_avis || 'Annonce'}
                        </span>
                        {r.commercant && <span style={{ fontSize: 13 }}>{r.commercant}</span>}
                      </div>
                      {r.date_parution && (
                        <span style={{ fontSize: 11, color: 'var(--text-light)', whiteSpace: 'nowrap' }}>
                          🗓 {new Date(r.date_parution).toLocaleDateString('fr-FR')}
                        </span>
                      )}
                    </div>
                    {r.tribunal && <div style={{ fontSize: 11, color: 'var(--text-light)', marginTop: 4 }}>Tribunal: {r.tribunal}</div>}
                    {r.description && <div style={{ fontSize: 12, marginTop: 4, color: '#555' }}>{r.description.substring(0, 200)}</div>}
                    {r.url && (
                      <a href={r.url} target="_blank" rel="noopener noreferrer"
                         style={{ fontSize: 11, color: '#C62828', textDecoration: 'none', marginTop: 4, display: 'inline-block' }}>
                        Voir l'annonce →
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function InvestorAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ secteur: '', min_note: '', adressage_client: '' });
  const [digest, setDigest] = useState(null);
  const [digestLoading, setDigestLoading] = useState(true);

  const load = () => getMyAlerts().then(setAlerts).catch(console.error);

  useEffect(() => {
    load();
    // Load investor digest (news, dirigeants, bodacc)
    setDigestLoading(true);
    getInvestorDigest()
      .then(data => {
        setDigest(data);
        setDigestLoading(false);
      })
      .catch(err => {
        console.error('Digest error:', err);
        setDigest({ news: [], dirigeants: [], bodacc: [] });
        setDigestLoading(false);
      });
  }, []);

  const handleCreate = async () => {
    const criteria = {};
    if (form.secteur) criteria.secteur = form.secteur;
    if (form.min_note) criteria.min_note = form.min_note;
    if (form.adressage_client) criteria.adressage_client = form.adressage_client;
    await createAlert(criteria);
    setShowForm(false);
    setForm({ secteur: '', min_note: '', adressage_client: '' });
    load();
  };

  const handleDelete = async (id) => {
    await deleteAlert(id);
    load();
  };

  const totalNewsCount = digest ? (digest.news?.length || 0) + (digest.dirigeants?.length || 0) + (digest.bodacc?.length || 0) : 0;

  return (
    <div style={{ padding: '32px 0' }}>
      <div className="container" style={{ maxWidth: 900 }}>

        {/* News blocks */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div>
              <h1 style={{ marginBottom: 4 }}>Veille & Alertes</h1>
              <p style={{ color: 'var(--text-light)', fontSize: 14 }}>
                Informations récentes sur vos startups suivies (favoris & portefeuille)
              </p>
            </div>
            {!digestLoading && totalNewsCount > 0 && (
              <span className="badge" style={{ background: 'var(--primary)', color: 'white', fontSize: 13, padding: '6px 14px' }}>
                {totalNewsCount} résultat{totalNewsCount > 1 ? 's' : ''}
              </span>
            )}
          </div>

          {digest && digest.startups?.length === 0 && !digestLoading && (
            <div className="card" style={{ marginBottom: 24, textAlign: 'center', padding: 40, color: 'var(--text-light)' }}>
              <p style={{ fontSize: 16, marginBottom: 8 }}>Aucune startup dans vos favoris ou votre portefeuille.</p>
              <p style={{ fontSize: 13 }}>Ajoutez des startups à vos favoris pour recevoir des actualités.</p>
            </div>
          )}

          <NewsSection news={digest?.news || []} loading={digestLoading} />
          <DirigeantSection dirigeants={digest?.dirigeants || []} loading={digestLoading} />
          <BodaccSection bodacc={digest?.bodacc || []} loading={digestLoading} />

          {!digestLoading && digest?.generated_at && (
            <div style={{ textAlign: 'right', fontSize: 11, color: 'var(--text-light)', marginBottom: 24 }}>
              Dernière mise à jour : {new Date(digest.generated_at).toLocaleString('fr-FR')}
            </div>
          )}
        </div>

        {/* Separator */}
        <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '32px 0' }} />

        {/* Existing alerts section */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2>Mes Alertes Personnalisées</h2>
          <button onClick={() => setShowForm(!showForm)} className="btn btn-primary">
            {showForm ? 'Annuler' : 'Nouvelle alerte'}
          </button>
        </div>

        <p style={{ color: 'var(--text-light)', marginBottom: 24, fontSize: 14 }}>
          Recevez une notification lorsqu'une nouvelle startup correspondant à vos critères est publiée.
        </p>

        {showForm && (
          <div className="card" style={{ marginBottom: 24 }}>
            <h3 style={{ marginBottom: 16 }}>Configurer une alerte</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 16 }}>
              <div>
                <label className="form-label">Secteur</label>
                <select value={form.secteur} onChange={e => setForm(f => ({ ...f, secteur: e.target.value }))} className="form-input">
                  <option value="">Tous</option>
                  {['Fintech', 'Insurtech', 'Regtech', 'HealthTech', 'Greentech', 'Immotech'].map(s =>
                    <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <label className="form-label">Note ISI min.</label>
                <select value={form.min_note} onChange={e => setForm(f => ({ ...f, min_note: e.target.value }))} className="form-input">
                  <option value="">Toutes</option>
                  <option value="7">7+ (Résilient)</option>
                  <option value="5">5+</option>
                  <option value="4">4+</option>
                </select>
              </div>
              <div>
                <label className="form-label">Clientèle</label>
                <select value={form.adressage_client} onChange={e => setForm(f => ({ ...f, adressage_client: e.target.value }))} className="form-input">
                  <option value="">Tous</option>
                  <option value="B2B">B2B</option>
                  <option value="B2C">B2C</option>
                  <option value="B2B2C">B2B2C</option>
                </select>
              </div>
            </div>
            <button onClick={handleCreate} className="btn btn-accent">Créer l'alerte</button>
          </div>
        )}

        {alerts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-light)' }}>
            Aucune alerte configurée
          </div>
        ) : (
          <div style={{ display: 'grid', gap: 12 }}>
            {alerts.map(a => {
              const c = typeof a.criteria_json === 'string' ? JSON.parse(a.criteria_json) : a.criteria_json;
              return (
                <div key={a.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      {c.secteur && <span className="badge badge-secteur">{c.secteur}</span>}
                      {c.min_note && <span className="badge badge-vert">Note &ge; {c.min_note}</span>}
                      {c.adressage_client && <span className="badge badge-client">{c.adressage_client}</span>}
                      {!c.secteur && !c.min_note && !c.adressage_client && <span style={{ color: 'var(--text-light)' }}>Tous critères</span>}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--text-light)', marginTop: 6 }}>
                      Créée le {new Date(a.created_at).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                  <button onClick={() => handleDelete(a.id)} className="btn" style={{ background: '#FFEBEE', color: '#C62828', fontSize: 12 }}>
                    Supprimer
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
